import {Component } from '@angular/core';
import {getAppThemeName, setCookie} from 'src/app/core/functions/common.function';
import { NoticeInfo } from 'src/app/core/interfaces/common';
import { CommonService } from '../../services/common.service';
import {DBButtonModule, DBIconModule, DBModalModule, DBModalService, DBPanelModule} from "@db/db-core";
import {PrivacyModalComponent} from "../privacy-modal/privacy-modal.component";
import {TranslatePipe} from "@ngx-translate/core";
import {LanguageMenuComponent} from "../language-menu/language-menu.component";

@Component({
  standalone: true,
  selector: 'app-cookie-notice',
  imports: [DBModalModule, TranslatePipe, DBButtonModule, DBPanelModule, DBIconModule, LanguageMenuComponent],
  templateUrl: './cookie-notice.modal.html',
  styleUrls: ['./cookie-notice.modal.scss']
})
export class CookieNoticeModal {

  public noticeInfo: NoticeInfo = {cookieAccepted: false};
  private readonly modalService: DBModalService;
  private readonly appService: CommonService;

  constructor(
    modalService: DBModalService,
    appService: CommonService
  ) {
    this.modalService = modalService;
    this.appService = appService;
  }

  onClickOK() {
    setCookie('COOKIE_ACCEPTED', '1001', 1);
    this.noticeInfo = ({...this.noticeInfo, cookieAccepted: true});
    this.appService.changeNoticeAcceptanceStatus(this.noticeInfo);
    this.modalService.close();
  }

  public openPrivacyModal( ): void {
    this.modalService.close().then(() => {
      window.scrollTo(0, 0);
      this.modalService.openWithComponent( PrivacyModalComponent, { closeOnBackdropClickOrEscKey: false });
    });
  }

  protected readonly getAppThemeName = getAppThemeName;
}
